export const deliveryWorkspaceEn = {
  line: "Line",
  field_shipTo: "Recipient",
  field_deliveryDate: "Receipt date",
  field_receiverName: "Receiver",
  field_deliveryMode: "Delivery mode",
  field_vehicleNo: "Vehicle",
  field_driverName: "Driver",
  field_driverPhone: "Driver phone",
  field_respBy: "Responsible",
  field_remarks: "Remarks",
  field_orderedQty: "Planned quantity",
  field_deliveredQty: "Received quantity",

  replaceSourceHint:
    "Changing the source replaces this unsaved shipment plan and recipient. Vehicle and driver details remain for review.",
  edit: "Edit delivery note",
  correct: "Correct confirmed receipt",
  editorHint:
    "Plan this shipment separately from actual receipt. Zero planned quantity excludes a line on create. Completion and corrections are recorded in history.",
  chooseSource: "Choose and review source",
  sourceLoading: "Reload the source before creating the shipment.",
  confirmAction: "Confirm delivery update",
  confirmHint:
    "Review planned/received quantities, recipient, date and reason. Saving records this action in the audit history.",
  planned: "Planned quantity",
  received: "Received quantity",
  plannedReceived: "Planned / received",
  remaining: "Available for this shipment",
  shortage: "Short receipt",
  receiptDate: "Actual receipt date",
  receiver: "Confirmed by receiver",
  reason: "Reason / shortage explanation",
  recipientRequired: "Enter the complete delivery recipient.",
  preview: "Saved note · Print preview",
  dispatch: "Mark in transit",
  confirmReceipt: "Confirm receipt",
  cancelShipment: "Cancel shipment",
  archive: "Archive delivery note",
  archiveHint:
    "Archiving hides the note from the active list. Confirmed received quantities and all history remain counted.",
  nextShipment: "Create next shipment from this source",
  completedHint:
    "This receipt is finalized. Corrections require a reason and preserve the previous values; archiving does not reverse receipt.",
  cancelledHint:
    "This shipment is cancelled and no longer reserves quantities. Create a new shipment to resume delivery.",
  archivedPlanHint: "This archived plan no longer reserves source quantities.",
  unavailableCustomer: "Selected customer (archived or unavailable)",
  sourceArchived:
    "Source archived or unavailable; the saved delivery snapshot is retained",
  planningHint:
    "Planned quantities reserve source availability. Actual receipt is finalized only when this note is marked Delivered.",
  history: "Shipment history",
  legacyHistory: "No detailed events were captured for this legacy note.",
  event_created: "Created",
  event_updated: "Details updated",
  event_status_changed: "Status changed",
  event_corrected: "Confirmed receipt corrected",
  event_direct_reviewed: "Direct delivery reviewed",
  event_archived: "Archived",
  lifecycle: "Active / archived",
  from: "Note date from",
  to: "Note date to",
  delivery_quantity_invalid:
    "Enter explicit non-negative whole quantities; received quantity cannot exceed planned quantity.",
  delivery_transition_invalid:
    "This status change is not allowed. Dispatch before confirming receipt.",
  delivery_completion_required:
    "Enter the receiver, actual receipt date and received quantities before completing.",
  delivery_reason_required: "Explain the shortage or correction before saving.",
  delivery_cancel_invalid:
    "Cancellation requires a reason and no received goods. Correct actual receipt through the receipt workflow.",
  delivery_finalized:
    "This note is finalized. Use an explicit correction or create a new shipment.",
  delivery_correction_required:
    "Only a completed receipt can be corrected, with a reason.",
  delivery_overallocated:
    "The requested quantity exceeds current availability. Reload the remaining quantities.",
  delivery_no_remaining: "No quantity remains to ship from this source.",
  delivery_source_invalid: "Choose valid lines from the selected source.",
  delivery_source_changed:
    "The source changed after preview. Reload and review again.",
  // Giao hàng = xuất kho (18/09/2026).
  fulfillment: "Source",
  fulfillmentStock: "From stock",
  fulfillmentDirect: "Direct (not via warehouse)",
  fulfillmentChoose: "Choose…",
  stockLot: "Lot / note",
  stockNone: "No stock of this item in any warehouse",
  directNotePlaceholder: "e.g. factory ships straight to the customer",
  bulkDirectNote: "One note for all direct lines",
  applyDirectNote: "Fill empty direct lines ({{count}})",
  positionOption: "{{lot}} · {{available}} available · {{warehouse}} {{location}}",
  fulfillmentHint: "Stock is issued when goods leave the warehouse. From stock: the planned quantity is taken from the chosen lot when you save. Direct: goods go straight from the factory or supplier to the customer — a note is required.",
  legacySourceHint: "This note was dispatched before stock was issued at dispatch: choose the source for the lines still missing one. Lines from stock issue the planned quantity.",
  cancelReversesStock: "Cancelling a note in transit reverses its stock issue: the goods go back to the same lot and location.",
  directWithStockWarning: "{{qty}} of this item is in stock — a direct delivery will be flagged for an approver to review.",
  directWithStockAt: "{{qty}} in stock when shipped direct",
  directReviewedBy: "reviewed by {{name}}",
  directNotReviewed: "awaiting approver review",
  reviewDirect: "Mark as reviewed",
  sourcesTitle: "Goods source per line",
  sourcesIntro: "Where each line's goods came from: issued from a lot when the goods left the warehouse, or shipped direct by the factory or supplier. Not printed on the delivery note.",
  sourcesCheck: "Check",
  reviewDirectTitle: "Review a direct delivery while stock was available",
  reviewDirectNote: "Note (why it was shipped direct)",
  reviewDirectSave: "Record review",
  delivery_cancel_returned: "Goods have already been returned against this note; it cannot be cancelled. Handle it with a return.",
  delivery_stock_issued: "Stock was issued for this note; it cannot be archived. Return the goods first.",
  delivery_direct_review_invalid: "This line needs no review (it is not a direct delivery made while stock was available).",
  delivery_fulfillment_required: "Choose the source (from stock or direct) for every delivered line.",
  delivery_direct_note_required: "Direct delivery needs a note of at least 5 characters (who shipped it).",
  delivery_stock_position_required: "Choose the lot to issue for each line delivered from stock.",
  delivery_stock_position: "The chosen lot position no longer exists. Reload and choose again.",
  delivery_stock_product: "The chosen lot belongs to a different product or sub-ref.",
  delivery_stock_unit: "The chosen lot is in a different unit from the delivery line.",
  delivery_stock_lot: "The chosen lot is not the lot written on the delivery line.",
  delivery_stock_short: "Not enough available stock in the chosen lot. Reduce the quantity, choose another lot or deliver direct.",
  delivery_stock_locked: "This line was issued from stock; its delivered quantity can no longer be corrected. Use a return (RMA) instead.",
  delivery_stock_reserved: "Part of the chosen lot is reserved for another order; the rest is not enough. Choose another lot, reduce the quantity or release the reservation first.",
  delivery_stock_source: "The chosen lot no longer matches the delivery line (item, unit, lot, or its receipt was cancelled). Reload and choose again.",
  delivery_stock_changed: "Stock changed while saving. Reload the page and choose again.",
  stockOptionsError: "Could not load the lots in stock. Nothing has been chosen for you — try again.",
  retry: "Try again",
  correctionSourceHint: "Lines that were 0 at delivery and now get a quantity must say where the goods came from, as when confirming delivery.",
  delivery_changed:
    "The note changed while you were editing. Reload and review the latest version.",
  delivery_retry_conflict:
    "This request was already used with different data. Review the saved note before retrying.",
  delivery_lot_required:
    "Enter actual LOTs on the source document for every P-Process line before shipment.",
  delivery_plan_locked:
    "Planned quantities are fixed after dispatch. Record actual receipt or create another shipment.",
  delivery_receipt_state:
    "A Pending plan cannot record received goods. Dispatch first.",
  delivery_in_transit:
    "Complete or cancel the in-transit shipment before archiving.",
  delivery_legacy_links:
    "Historical source links are ambiguous. Review them before allocating another shipment.",
  delivery_source_fulfilled:
    "Confirmed deliveries reference this source. Correct the receipt history before changing source lines.",
};
export const deliveryWorkspaceVi = {
  line: "Dòng",
  field_shipTo: "Nơi nhận",
  field_deliveryDate: "Ngày nhận",
  field_receiverName: "Người nhận",
  field_deliveryMode: "Cách giao",
  field_vehicleNo: "Xe",
  field_driverName: "Tài xế",
  field_driverPhone: "Điện thoại tài xế",
  field_respBy: "Phụ trách",
  field_remarks: "Ghi chú",
  field_orderedQty: "Số dự kiến",
  field_deliveredQty: "Số thực nhận",

  replaceSourceHint:
    "Đổi nguồn sẽ thay kế hoạch giao và người nhận chưa lưu. Thông tin xe và tài xế được giữ để kiểm tra.",
  edit: "Sửa phiếu giao hàng",
  correct: "Đính chính số nhận đã xác nhận",
  editorHint:
    "Lập số dự kiến giao riêng với số nhận thực tế. Khi tạo, số dự kiến 0 bỏ dòng đó. Hoàn tất và đính chính đều được ghi lịch sử.",
  chooseSource: "Chọn và kiểm tra chứng từ nguồn",
  sourceLoading: "Tải lại nguồn trước khi tạo đợt giao.",
  confirmAction: "Xác nhận cập nhật giao hàng",
  confirmHint:
    "Kiểm tra số dự kiến/thực nhận, người nhận, ngày và lý do. Lưu sẽ ghi thao tác vào lịch sử.",
  planned: "Số dự kiến giao",
  received: "Số nhận thực tế",
  plannedReceived: "Dự kiến / thực nhận",
  remaining: "Có thể dùng cho đợt này",
  shortage: "Nhận thiếu",
  receiptDate: "Ngày nhận thực tế",
  receiver: "Người xác nhận nhận hàng",
  reason: "Lý do / giải thích nhận thiếu",
  recipientRequired: "Nhập đầy đủ thông tin nơi nhận hàng.",
  preview: "Phiếu đã lưu · Xem trước bản in",
  dispatch: "Chuyển sang đang giao",
  confirmReceipt: "Xác nhận nhận hàng",
  cancelShipment: "Hủy đợt giao",
  archive: "Lưu trữ phiếu giao hàng",
  archiveHint:
    "Lưu trữ ẩn phiếu khỏi danh sách hoạt động. Số đã nhận xác nhận và toàn bộ lịch sử vẫn được giữ và tính.",
  nextShipment: "Tạo đợt giao tiếp từ nguồn này",
  completedHint:
    "Đã chốt nhận hàng. Đính chính cần lý do và giữ giá trị trước đó; lưu trữ không đảo ngược việc nhận hàng.",
  cancelledHint:
    "Đợt giao đã hủy và không còn giữ chỗ số lượng. Tạo đợt mới để tiếp tục giao hàng.",
  archivedPlanHint: "Kế hoạch đã lưu trữ không còn giữ chỗ số lượng nguồn.",
  unavailableCustomer: "Khách hàng đã chọn (đã lưu trữ hoặc không khả dụng)",
  sourceArchived:
    "Nguồn đã lưu trữ hoặc không còn khả dụng; thông tin phiếu giao đã lưu vẫn được giữ",
  planningHint:
    "Số dự kiến giữ chỗ trong lượng nguồn. Số nhận thực tế chỉ chốt khi phiếu chuyển sang Đã giao.",
  history: "Lịch sử đợt giao",
  legacyHistory: "Phiếu cũ chưa ghi sự kiện chi tiết.",
  event_created: "Đã tạo",
  event_updated: "Cập nhật thông tin",
  event_status_changed: "Đổi trạng thái",
  event_corrected: "Đính chính nhận hàng",
  event_direct_reviewed: "Đã xem lại dòng giao thẳng",
  event_archived: "Đã lưu trữ",
  lifecycle: "Hoạt động / lưu trữ",
  from: "Ngày phiếu từ",
  to: "Ngày phiếu đến",
  delivery_quantity_invalid:
    "Nhập số nguyên không âm rõ ràng; thực nhận không được vượt số dự kiến.",
  delivery_transition_invalid:
    "Không được chuyển trạng thái như vậy. Chuyển sang đang giao trước khi xác nhận nhận hàng.",
  delivery_completion_required:
    "Nhập người nhận, ngày nhận thực tế và số lượng nhận trước khi hoàn tất.",
  delivery_reason_required:
    "Giải thích phần nhận thiếu hoặc đính chính trước khi lưu.",
  delivery_cancel_invalid:
    "Hủy cần lý do và chưa có hàng đã nhận. Điều chỉnh thực nhận qua luồng nhận hàng.",
  delivery_finalized:
    "Phiếu đã chốt. Dùng chức năng đính chính hoặc tạo đợt giao mới.",
  delivery_correction_required:
    "Chỉ đính chính phiếu đã nhận hoàn tất và phải có lý do.",
  delivery_overallocated:
    "Số lượng yêu cầu vượt lượng đang có thể phân bổ. Tải lại số lượng còn lại.",
  delivery_no_remaining: "Nguồn này không còn số lượng để giao.",
  delivery_source_invalid: "Chọn dòng hợp lệ từ đúng chứng từ nguồn.",
  delivery_source_changed:
    "Nguồn đã thay đổi sau khi xem trước. Tải lại và kiểm tra.",
  // Giao hàng = xuất kho (18/09/2026).
  fulfillment: "Nguồn hàng",
  fulfillmentStock: "Xuất từ kho",
  fulfillmentDirect: "Giao thẳng (không qua kho)",
  fulfillmentChoose: "Chọn…",
  stockLot: "Lô xuất / ghi chú",
  stockNone: "Không kho nào có hàng của mã này",
  directNotePlaceholder: "Ví dụ: nhà máy giao thẳng cho khách",
  bulkDirectNote: "Ghi chú chung cho các dòng giao thẳng",
  applyDirectNote: "Điền vào {{count}} dòng còn trống",
  positionOption: "{{lot}} · còn {{available}} · {{warehouse}} {{location}}",
  fulfillmentHint: "Xuất kho lúc hàng rời kho. Xuất từ kho: tồn của lô đã chọn bị trừ đúng số dự kiến giao ngay khi lưu. Giao thẳng: hàng đi thẳng từ nhà máy hoặc nhà cung cấp tới khách — phải ghi chú.",
  legacySourceHint: "Phiếu này xuất phát trước khi hệ thống trừ kho lúc hàng rời kho: chọn nguồn hàng cho các dòng còn thiếu. Dòng xuất từ kho trừ đúng số dự kiến giao.",
  cancelReversesStock: "Huỷ phiếu đang giao sẽ đảo phiếu xuất kho của nó: hàng về lại đúng lô, đúng vị trí cũ.",
  directWithStockWarning: "Kho đang có {{qty}} mã này — giao thẳng sẽ được báo để người có quyền Duyệt xem lại.",
  directWithStockAt: "Kho có {{qty}} lúc chọn giao thẳng",
  directReviewedBy: "đã xem: {{name}}",
  directNotReviewed: "chờ người Duyệt xem lại",
  reviewDirect: "Ghi nhận đã xem",
  sourcesTitle: "Nguồn hàng từng dòng",
  sourcesIntro: "Hàng của từng dòng đi từ đâu: xuất từ lô lúc hàng rời kho, hay nhà máy / nhà cung cấp giao thẳng. Không in lên phiếu giao gửi khách.",
  sourcesCheck: "Kiểm soát",
  reviewDirectTitle: "Xem lại dòng giao thẳng lúc kho có hàng",
  reviewDirectNote: "Ghi chú (vì sao giao thẳng)",
  reviewDirectSave: "Ghi nhận",
  delivery_cancel_returned: "Đã có hàng trả lại theo phiếu này nên không huỷ được. Xử lý bằng phiếu trả hàng.",
  delivery_stock_issued: "Phiếu này đã xuất kho nên không lưu trữ được. Trả hàng bằng phiếu trả hàng trước.",
  delivery_direct_review_invalid: "Dòng này không cần xem lại (không phải giao thẳng lúc kho có hàng).",
  delivery_fulfillment_required: "Chọn nguồn hàng (xuất từ kho hay giao thẳng) cho mọi dòng có số giao.",
  delivery_direct_note_required: "Giao thẳng cần ghi chú ít nhất 5 ký tự (ai giao).",
  delivery_stock_position_required: "Chọn lô xuất cho mỗi dòng xuất từ kho.",
  delivery_stock_position: "Vị trí lô đã chọn không còn. Tải lại và chọn lại.",
  delivery_stock_product: "Lô đã chọn thuộc sản phẩm hoặc mã phụ khác.",
  delivery_stock_unit: "Lô đã chọn khác đơn vị với dòng giao.",
  delivery_stock_lot: "Lô đã chọn không phải lô ghi trên dòng giao.",
  delivery_stock_short: "Lô đã chọn không đủ hàng dùng được. Giảm số lượng, chọn lô khác hoặc giao thẳng.",
  delivery_stock_locked: "Dòng này đã xuất kho; không sửa được số giao nữa. Dùng phiếu trả hàng (RMA).",
  delivery_stock_reserved: "Một phần lô đã chọn đang giữ chỗ cho đơn khác; phần còn lại không đủ. Chọn lô khác, giảm số lượng hoặc bỏ giữ chỗ trước.",
  delivery_stock_source: "Lô đã chọn không còn khớp dòng giao (mã, đơn vị, số lô, hoặc phiếu nhập của lô đã huỷ). Tải lại và chọn lại.",
  delivery_stock_changed: "Tồn kho vừa thay đổi trong lúc lưu. Tải lại trang và chọn lại.",
  stockOptionsError: "Không tải được các lô đang có trong kho. Hệ thống chưa chọn gì thay bạn — thử lại.",
  retry: "Thử lại",
  correctionSourceHint: "Dòng lúc xác nhận giao là 0 mà nay nhập số giao thì phải chọn nguồn hàng, như lúc xác nhận.",
  delivery_changed:
    "Phiếu đã thay đổi trong lúc sửa. Tải lại và kiểm tra bản mới nhất.",
  delivery_retry_conflict:
    "Yêu cầu đã được dùng với dữ liệu khác. Kiểm tra phiếu đã lưu trước khi thử lại.",
  delivery_lot_required:
    "Nhập LOT thực tế trên chứng từ nguồn cho mọi dòng P-Process trước khi giao.",
  delivery_plan_locked:
    "Số dự kiến được khóa sau khi bắt đầu giao. Ghi nhận thực nhận hoặc tạo đợt khác.",
  delivery_receipt_state:
    "Phiếu chờ giao chưa thể ghi hàng thực nhận. Chuyển sang đang giao trước.",
  delivery_in_transit: "Hoàn tất hoặc hủy đợt đang giao trước khi lưu trữ.",
  delivery_legacy_links:
    "Tham chiếu nguồn của lịch sử chưa rõ. Kiểm tra trước khi phân bổ đợt khác.",
  delivery_source_fulfilled:
    "Đã có nhận hàng xác nhận từ nguồn này. Đính chính lịch sử nhận trước khi đổi dòng nguồn.",
};
export const deliveryWorkspaceZh = {
  line: "明细",
  field_shipTo: "收件人",
  field_deliveryDate: "收货日期",
  field_receiverName: "收货人",
  field_deliveryMode: "送货方式",
  field_vehicleNo: "车辆",
  field_driverName: "司机",
  field_driverPhone: "司机电话",
  field_respBy: "负责人",
  field_remarks: "备注",
  field_orderedQty: "计划数量",
  field_deliveredQty: "实收数量",

  replaceSourceHint:
    "更换来源将替换尚未保存的出货计划及收件人。车辆与司机信息保留供核对。",
  edit: "编辑送货单",
  correct: "更正已确认收货",
  editorHint:
    "出货计划与实际收货分开记录。创建时计划数量为零则不含该明细。完成及更正均保留历史。",
  chooseSource: "选择并核对来源",
  sourceLoading: "创建出货前请重新加载来源。",
  confirmAction: "确认送货更新",
  confirmHint: "请核对计划／实收数量、收件人、日期及原因。保存后记录至历史。",
  planned: "计划出货数量",
  received: "实收数量",
  plannedReceived: "计划／实收",
  remaining: "此批可用数量",
  shortage: "短收",
  receiptDate: "实际收货日期",
  receiver: "收货确认人",
  reason: "原因／短收说明",
  recipientRequired: "请填写完整收件信息。",
  preview: "已保存单据 · 打印预览",
  dispatch: "标记运送中",
  confirmReceipt: "确认收货",
  cancelShipment: "取消出货",
  archive: "归档送货单",
  archiveHint: "归档会从有效列表隐藏单据。已确认收货数量及历史仍保留并计入。",
  nextShipment: "从此来源创建下一批出货",
  completedHint: "收货已确认。更正须填原因并保留原值；归档不会撤销收货。",
  cancelledHint: "此批交货已取消，不再预留数量。请创建新批次以继续交货。",
  archivedPlanHint: "此归档计划不再预留来源数量。",
  unavailableCustomer: "已选客户（已归档或无法使用）",
  sourceArchived: "来源已归档或无法使用；已保存的交货快照仍保留",
  planningHint: "计划数量预留来源可用量。仅标记已送达后才确认实收。",
  history: "出货历史",
  legacyHistory: "此旧单据未记录详细事件。",
  event_created: "已创建",
  event_updated: "数据已更新",
  event_status_changed: "状态已变更",
  event_corrected: "已更正确认收货",
  event_direct_reviewed: "已查看直送明细",
  event_archived: "已归档",
  lifecycle: "有效／归档",
  from: "单据起始日期",
  to: "单据结束日期",
  delivery_quantity_invalid: "请输入明确的非负整数；实收不得超过计划数量。",
  delivery_transition_invalid: "不允许此状态变更。请先标记运送中，再确认收货。",
  delivery_completion_required: "完成前请输入收货人、实际日期及数量。",
  delivery_reason_required: "保存前请说明短收或更正原因。",
  delivery_cancel_invalid: "取消须填原因且未收货。请通过收货流程更正实收。",
  delivery_finalized: "此单据已结案。请使用更正功能或创建新出货。",
  delivery_correction_required: "仅可更正已完成收货，且必须填写原因。",
  delivery_overallocated: "要求数量超过目前可用量。请重新加载余额。",
  delivery_no_remaining: "此来源已无可出货数量。",
  delivery_source_invalid: "请选择来源单据的有效明细。",
  delivery_source_changed: "来源在预览后已更改。请重新加载并核对。",
  // Giao hàng = xuất kho (18/09/2026).
  fulfillment: "货源",
  fulfillmentStock: "仓库出库",
  fulfillmentDirect: "直送（不经仓库）",
  fulfillmentChoose: "请选择…",
  stockLot: "出库批次／备注",
  stockNone: "所有仓库都没有此品项的库存",
  directNotePlaceholder: "例如：工厂直接送至客户",
  bulkDirectNote: "直送明细共用备注",
  applyDirectNote: "填入 {{count}} 条空白明细",
  positionOption: "{{lot}} · 可用 {{available}} · {{warehouse}} {{location}}",
  fulfillmentHint: "货物离开仓库时即出库。仓库出库：保存时即从所选批次扣减预计出货数量。直送：货物由工厂或供应商直接送至客户——必须填写备注。",
  legacySourceHint: "此送货单在“离仓即出库”规则前已出发：请为尚未选择货源的明细选择货源。仓库出库的明细扣减预计出货数量。",
  cancelReversesStock: "取消运送中的送货单会冲销其出库：货物回到原批次、原库位。",
  directWithStockWarning: "此品项目前库存 {{qty}}——选择直送将通知具“审核”权限者查看。",
  directWithStockAt: "选择直送时库存 {{qty}}",
  directReviewedBy: "已查看：{{name}}",
  directNotReviewed: "待审核者查看",
  reviewDirect: "记录已查看",
  sourcesTitle: "各明细货源",
  sourcesIntro: "各明细的货物来源：离仓时由批次出库，或由工厂／供应商直送。不会打印在给客户的送货单上。",
  sourcesCheck: "管控",
  reviewDirectTitle: "查看有库存时的直送明细",
  reviewDirectNote: "备注（为何直送）",
  reviewDirectSave: "记录",
  delivery_cancel_returned: "此送货单已有退货，无法取消。请以退货单处理。",
  delivery_stock_issued: "此送货单已出库，无法归档。请先以退货单退回货物。",
  delivery_direct_review_invalid: "此明细不需查看（并非有库存时的直送）。",
  delivery_fulfillment_required: "请为每一条有出货数量的明细选择货源（仓库出库或直送）。",
  delivery_direct_note_required: "直送需填写至少 5 个字的备注（由谁出货）。",
  delivery_stock_position_required: "请为每一条仓库出库的明细选择出库批次。",
  delivery_stock_position: "所选批次库位已不存在，请重新加载后再选。",
  delivery_stock_product: "所选批次属于其他产品或子参考。",
  delivery_stock_unit: "所选批次的单位与出货明细不同。",
  delivery_stock_lot: "所选批次不是出货明细上记载的批次。",
  delivery_stock_short: "所选批次的可用库存不足。请减少数量、改选其他批次或改为直送。",
  delivery_stock_locked: "此明细已出库，出货数量不可再更正，请改用退货（RMA）。",
  delivery_stock_reserved: "所选批次有部分已为其他订单预留，剩余数量不足。请改选其他批次、减少数量或先解除预留。",
  delivery_stock_source: "所选批次已与出货明细不符（品号、单位、批号，或该批次的入库单已取消）。请重新加载后再选。",
  delivery_stock_changed: "保存时库存已变动，请重新加载页面后再选。",
  stockOptionsError: "无法加载库存批次。系统没有代为选择——请重试。",
  retry: "重试",
  correctionSourceHint: "出货确认时为 0、现在填入出货数量的明细，须如确认出货时一样选择货源。",
  delivery_changed: "编辑期间单据已更改。请重新加载并核对最新版本。",
  delivery_retry_conflict: "此请求已用于不同数据。重试前请核对已保存单据。",
  delivery_lot_required:
    "出货前请在来源单据为所有 P-Process 明细填写实际 LOT。",
  delivery_plan_locked: "出货后计划数量固定。请记录实收或创建另一批出货。",
  delivery_receipt_state: "待处理计划不能记录实收。请先出货。",
  delivery_in_transit: "归档前请完成或取消运送中的出货。",
  delivery_legacy_links: "历史来源关联不明确。分配另一批出货前请先核对。",
  delivery_source_fulfilled:
    "已有确认收货引用此来源。变更来源明细前请先更正收货历史。",
};
